import { PaginationInfo } from ".";

export const EntityWithIdFields = {
  Id: "id",
} as const;

export const EntityWithIdAndDescriptionFields = {
  ...EntityWithIdFields,
  Description: "descripcion",
} as const;

/**
 * Tipo de entidad básico.
 */
export type EntityWithId<TId = number> = {
  [EntityWithIdFields.Id]: TId;
};

/**
 * Tipo de entidad con id y descripción.
 */
export type EntityWithIdAndDescription<TId = number> = EntityWithId<TId> & {
  [EntityWithIdAndDescriptionFields.Description]: string;
};

export const EntityListWithPaginationFields = {
  List: "lista",
  Pagination: "paginacion",
} as const;

export type EntityListWithPagination<TEntity> = {
  [EntityListWithPaginationFields.List]: TEntity[];
  [EntityListWithPaginationFields.Pagination]: PaginationInfo;
};
